
  import { mapGetters } from 'vuex';
  import inRange from 'lodash/inRange';

  export default {
    props: {
      inputAttrs: { type: Object, default () { return {}; } },
      field: { type: String, required: true },
      modelName: { type: String, default () { return null; } },
      required: { type: Boolean, default: false },
      value: { type: null, required: true }
    },
    data () {
      return { dayValue: null, monthValue: null, yearValue: null };
    },
    computed: {
      ...mapGetters('utils', { formErrors: 'formErrors' }),
      date: {
        get () {
          if (!this.fullDate) {
            return null;
          }
          return new Date(this.yearValue, parseInt(this.monthValue, 10) - 1, this.dayValue, 0, 0, 0);
        }
      },
      dateRange () {
        return ['max', 'min'].reduce((h, field) => {
          const attr = this.inputAttrs[`date-${field}`];
          h[field] = this.$dateOnly(attr);
          return h;
        }, {});
      },
      formDate () {
        return this.modelName ? this.$formGet(this.modelName, this.field) : null;
      },
      fullDate () {
        return !!this.dayValue && !!this.monthValue && !!this.yearValue && this.yearValue.length === 4;
      },
      maxDay () {
        if (!this.monthValue) {
          return 31;
        }
        return 31;
      },
      maxYear () {
        return this.dateRange.max && this.dateRange.max.getFullYear();
      },
      minYear () {
        return this.dateRange.min && this.dateRange.min.getFullYear();
      }
    },
    watch: {
      formDate: {
        immediate: true,
        handler (newDate, oldDate) {
          if (newDate && (!oldDate || (newDate !== oldDate))) {
            const date = this.$dateOnly(newDate);
            this.dayValue = this.$dateTime(date, 'dd');
            this.monthValue = this.$dateTime(date, 'MM');
            this.yearValue = this.$dateTime(date, 'yyyy');
          }
        }
      }
    },
    mounted () {
      this.validate();
    },
    methods: {
      backspace ($el) {
        const fields = ['day', 'month', 'year'];
        const pos = fields.indexOf($el.getAttribute('data-field'));
        if (pos && $el.value.length === 0) {
          this.$refs[fields[pos - 1]].focus();
          return false;
        };
      },
      inputDay (val) {
        if (val.match(/^\d\d$/) && inRange(parseInt(val, 10), 1, this.maxDay)) {
          this.dayValue = val;
          this.$refs.month.focus();
        }
      },
      inputMonth (val) {
        if (val.match(/^\d\d$/) && inRange(parseInt(val, 10), 1, 12)) {
          this.monthValue = val;
          this.$refs.year.focus();
        }
      },
      inputYear (val) {
        if (val.match(/^\d\d\d\d$/) && inRange(parseInt(val, 10), this.minYear, this.maxYear)) {
          this.yearValue = val;
        }
      },
      validate () {
        if (!this.date) {
          return;
        }
        let error = null;
        if (isNaN(this.date)) {
          error = (this.$t('errors.dateInvalid'));
        } else if (this.dateRange.max && this.$dateFns.isAfter(this.date, this.dateRange.max)) {
          error = this.$t('errors.dateAfterMax', [this.$dateTime(this.dateRange.max, 'shortDate')]);
        } else if (this.dateRange.min && this.$dateFns.isBefore(this.date, this.dateRange.min)) {
          error = this.$t('errors.dateBeforeMin', [this.$dateTime(this.dateRange.min, 'shortDate')]);
        }
        if (error) {
          this.$el.querySelectorAll('input').forEach($input => $input.setAttribute('data-errors', true));
          this.$refs.year.setCustomValidity(error);
          this.$refs.year.reportValidity();
        } else {
          this.$el.querySelectorAll('input').forEach($input => {
            $input.setCustomValidity('');
            $input.removeAttribute('data-errors');
            this.$refs.year.reportValidity();
          });
          this.$emit('input', this.$dateTime(this.date));
        }
      }
    }
  };
